import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";

export default function Copyright() {
  const version = process.env.REACT_APP_VERSION;
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Typography
        variant="body2"
        color="textSecondary"
        align="center"
        display={"inline"}
        style={{
          fontSize: ".76rem",
          paddingBottom: "1em",
        }}
      >
        {"Copyright © "}
        <Link color="inherit" href="https://www.vicon-security.com/">
          Anavio
        </Link>{" "}
        {new Date().getFullYear()}
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
        align="center"
        display={"inline"}
        style={{
          fontSize: ".76rem",
          paddingBottom: "1em",
        }}
      >
        {" ver " + version}
      </Typography>
    </div>
  );
}
